import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=472431a3&scoped=true&"
import script from "./base-info.vue?vue&type=script&lang=ts&"
export * from "./base-info.vue?vue&type=script&lang=ts&"
import style0 from "./base-info.vue?vue&type=style&index=0&id=472431a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472431a3",
  null
  
)

export default component.exports